import React, { useEffect } from "react";
import "../CSS/certifications.css";
import "../App.css";
import certificationsimg from "../Images/navbar/certifications.png";

function Certifications({ setindex }) {
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setindex(4);
        }
      });
    }, options);

    const divs = document.getElementById("cert");
    observer.observe(divs);

    return () => {
      observer.unobserve(divs);
    };
  }, []);
  useEffect(() => {
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: "0px",
      threshold: 0.5, // Trigger the callback when 50% of the element is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("slide-up");
        } else {
          entry.target.classList.remove("slide-up");
        }
      });
    }, options);

    const div1 = document.querySelectorAll(".inner");
    div1.forEach((item) => {
      observer.observe(item);
    });
    return () => {
      div1.forEach((item) => {
        observer.unobserve(item);
      });
    };
  });
  return (
    <div id="cert" className="certifications">
      <div className="header-block fontbold">
        <img src={certificationsimg} alt="intro" />
        Achievements
      </div>
      <br />
      <div>
        <div className="certi-grid">
          <div className="certi-grid-category fontbold inner">Achievements</div>
          <div className="inner">
            <div className="certi-grid-head namecolor fontbold">
              SSIP Hackathon :{" "}
            </div>
            <div className="certi-grid-details inner">
              Cleared regional round for Azadi ka Amrit Mahotsav Hackathon
              organized by Government of India
            </div>
          </div>
          <div className="inner">
            <div className="certi-grid-head namecolor fontbold ">
              Sciencious Hackathon :{" "}
            </div>
            <div className="certi-grid-details inner ">
              Received the best design award from a hackathon organized by
              Sciencious.com
            </div>
          </div>
          <div className="inner">
            <div className="certi-grid-head namecolor fontbold ">
              Grid National Quiz :{" "}
            </div>
            <div className="certi-grid-details inner ">
              Cleared quiz round for national level quiz organized by Flipkart
            </div>
          </div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div className="certi-grid-category fontbold inner">
            Certifications
          </div>
          <div className="inner">
            <div className="certi-grid-head namecolor fontbold">
              Built AI virtual Agent :{" "}
            </div>
            <div className="certi-grid-details inner">
              Completed a bootcamp on making a virtual agent organized by
              openweaver
            </div>
          </div>
          <div className="inner">
            <div className="certi-grid-head namecolor fontbold">
              Web Development Bootcamp :{" "}
            </div>
            <div className="certi-grid-details inner">
              Completed a bootcamp on web development organized by DevTown
            </div>
          </div>
          <div className="inner">
            <div className="certi-grid-head namecolor fontbold">
              Workshop on computer vision :{" "}
            </div>
            <div className="certi-grid-details inner">
              Completed a workshop on Computer Vision organized by Pantech
              Elearning
            </div>
          </div>
          <div className="inner">
            <div className="certi-grid-head namecolor fontbold">
              Bootcamp on Data Structures using C/C++ :{" "}
            </div>
            <div className="certi-grid-details inner">
              Completed a Bootcamp on Data Structures using C/C++ organized
              under Google Student Developers Club
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Certifications;
